'use strict';

var App = require('app');
var Misc = require('utils/misc');
var Utils = require('models/utils');

var AlarmModel = Backbone.Model.extend({
    defaults: {
        priority: 2,
        name: '',
        is_active: true,
        notify_corrected: true,
        send_email: true,
        conditions: [],
        trigger_time: 0,
        filter: {},
    },
    urlRoot: '/api/v1/alarms',
    initialize: function () {
        Backbone.Select.Me.applyTo(this);
    },
});

var AlarmCollection = Backbone.Collection.extend({
    model: AlarmModel,
    url: function () {
        var url = '/api/v1/';
        if (this.ownerId) {
            url += 'devices/' + this.ownerId + '/';
        }

        url += 'alarms';

        if (this.mailBox) {
            url += '?mailbox=true';
        }
        return url;
    },
    initialize: function (options) {
        Utils.SelectableCollection.applyTo(this, options);
    },
    getDeviceList: function (data) {
        var src = data.toJSON();
        var result = _.uniq(
            _.flatten(
                _.map(src, function (a) {
                    var list = _.map(a.devices, function (d) {
                        return d.id;
                    });
                    return list;
                })
            )
        );
        return result;
    },
});

var AlarmOccurrenceModel = Backbone.Model.extend({
    defaults: {},
    urlRoot: '/api/v1/alarm-occurrences',
    initialize: function () {
        Backbone.Select.Me.applyTo(this);
    },
});

var AlarmOccurrenceCollection = Backbone.Collection.extend({
    model: AlarmOccurrenceModel,
    initialize: function (options) {
        Utils.SelectableCollection.applyTo(this, options);
    },
});

function getOccurrenceListURL(filter) {
    return (
        '/api/v1/alarm-occurrences?' +
        _.compact(
            _.map(_.pairs(filter), function (f) {
                return f[1] ? f[0] + '=' + encodeURIComponent(f[1]) : '';
            })
        ).join('&')
    );
}

var API = {
    getAlarmList: function (ownerId, mailBox) {
        var self = this;
        var defer = $.Deferred();
        var list = new AlarmCollection();
        list.ownerId = ownerId;
        list.mailBox = mailBox;
        list.fetch({
            success: function (data) {
                data.updateCanEdit = function () {
                    _.each(data.models, function (m) {
                        m.set('can_edit', !m.get('read_only') && !m.get('is_active'));
                    });
                    defer.resolve(data);
                };

                data.updateCanEdit();
            },
            error: function (data) {
                defer.resolve(undefined);
            },
        });

        return defer.promise();
    },

    getAlarm: function (id) {
        var defer = $.Deferred();
        var item = new AlarmModel({ id: id });
        if (!id) {
            // no id? return the new empty model
            setTimeout(function () {
                defer.resolve(item);
            });
            return defer.promise();
        }
        item.fetch({
            success: function (data) {
                defer.resolve(data);
            },
            error: function (data) {
                defer.resolve(undefined);
            },
        });

        return defer.promise();
    },

    deleteAlarms: function (list, defer) {
        App.ajax({
            method: 'POST',
            url: '/api/v1/alarms/delete',
            data: JSON.stringify({
                list: _.map(list, function (item) {
                    return parseInt(item.id);
                }),
            }),
            success: function () {
                // delete all from the list
                _.each(list, function (m) {
                    m.collection.remove(m);
                });
                // callback
                defer.resolve(true);
            },
            error: function () {
                defer.resolve(false);
            },
        });
    },

    updateAlarms: function (list, fields) {
        return Misc.deferredFct(function (defer) {
            App.ajax({
                method: 'POST',
                url: '/api/v1/alarms/update',
                data: JSON.stringify({ list: list, fields: fields }),
                success: function (r) {
                    defer.resolve(true);
                },
                error: function (r) {
                    defer.resolve(false);
                },
            });
        });
    },

    updateAlarmOccurrences: function (act) {
        return App.ajaxDeferred({
            data: JSON.stringify(act),
            url: '/api/v1/alarm-occurrences/update',
            method: 'POST',
        });
    },

    getAlarmOccurrenceGroups: function (idx, deviceID) {
        return Misc.deferredFct(function (defer) {
            App.ajax({
                method: 'GET',
                url: '/api/v1/alarm-occurrences/groups/' + idx + (deviceID ? '?device_id=' + deviceID : ''),
                success: function (data) {
                    defer.resolve(data);
                },
                error: function (data) {
                    defer.resolve(undefined);
                },
            });
        });
    },

    getAlarmOccurrenceList: function (filter, grpLink) {
        return Misc.deferredFct(function (defer) {
            App.ajax({
                method: 'GET',
                url: getOccurrenceListURL(filter),
                success: function (data) {
                    defer.resolve({
                        count: data.count,
                        items: new AlarmOccurrenceCollection(data.items),
                        filter: filter,
                        grpLink: grpLink,
                        gotoPage: function (offset, count) {
                            var newFilter = Misc.cloneAsJSON(filter);
                            newFilter.limit = count;
                            newFilter.offset = offset;
                            return App.request('alarm-occurrences:list', newFilter);
                        },
                    });
                },
                error: function (data, response) {
                    defer.resolve(undefined);
                },
            });
        });
    },

    checkAlarmDeactivate: function (list) {
        return Misc.deferredFct(function (defer) {
            if (!list || !list.length) {
                defer.resolve(0);
                return;
            }

            App.ajax({
                method: 'GET',
                url: '/api/v1/alarms/check-update?list=' + list.join(','),
                success: function (data, response) {
                    defer.resolve(data);
                },
                error: function (data, response) {
                    defer.resolve(undefined);
                },
            });
        });
    },

    checkWebhookUrl: function (url, key, value) {
        return Misc.deferredFct(function (defer) {
            App.ajax({
                method: 'GET',
                url:
                    '/api/v1/company/webhook/test?url=' +
                    encodeURIComponent(url.trim()) +
                    '&key=' +
                    encodeURIComponent(key) +
                    '&value=' +
                    encodeURIComponent(value),
                success: function (data, response) {
                    defer.resolve(data);
                },
                error: function (data, response) {
                    defer.resolve(JSON.stringify(data.responseJSON));
                },
            });
        });
    },
};

App.reqres.setHandler('alarm:list', function (ownerID, mailBox) {
    return API.getAlarmList(ownerID, mailBox);
});

App.reqres.setHandler('alarm:get', function (id) {
    return API.getAlarm(id);
});

App.reqres.setHandler('alarm:update', function (list, fields) {
    return API.updateAlarms(list, fields);
});

App.reqres.setHandler('alarm:delete', function (list, defer) {
    return API.deleteAlarms(list, defer);
});

App.reqres.setHandler('alarm-occurrences:list', function (filter, grpLink) {
    return API.getAlarmOccurrenceList(filter, grpLink);
});

App.reqres.setHandler('alarm-occurrences:groups', function (idx, deviceID) {
    return API.getAlarmOccurrenceGroups(idx, deviceID);
});

App.reqres.setHandler('alarm-occurrences:update', function (action) {
    return API.updateAlarmOccurrences(action);
});

App.reqres.setHandler('alarm:update:check', function (list) {
    return API.checkAlarmDeactivate(list);
});

App.reqres.setHandler('webhook:url:test', function (url, key, value) {
    return API.checkWebhookUrl(url, key, value);
});
